var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.img+''+_vm.color,staticClass:"sp-pic"},[_c('img',{attrs:{"src":_vm.img}}),_c('div',{staticClass:"color-mask",style:(_vm.style_mask)})])}
var staticRenderFns = []

export { render, staticRenderFns }